import { useState, useEffect, useMemo } from "react";

const SearchBar = ({
    value = "",
    onChange = () => { },
    onClear = () => { },
    placeholder = "Rechercher...",
    disabled = false,
    debounce = 200,
}) => {
    const [local, setLocal] = useState(value);

    useEffect(() => setLocal(value), [value]);

    useEffect(() => {
        const id = setTimeout(() => onChange(local), debounce);
        return () => clearTimeout(id);
    }, [local, onChange, debounce]);

    const hasText = useMemo(() => !!local.trim(), [local]);

    const glowCls = (base, hover) =>
        hasText ? base : `bg-gray-300`;

    return (
            <div className="group z-0 relative p-1 rounded-full overflow-hidden *:transition-all *:duration-300">
                <form
                    role="form"
                    className="z-50 relative flex rounded-full"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <input
                        type="text"
                        placeholder={placeholder}
                        className="flex-1 px-4 py-2 rounded-full focus:outline-none text-gray-700 text-sm"
                        value={local}
                        onChange={(e) => setLocal(e.target.value)}
                        disabled={disabled}
                    />
                    {local && !disabled && (
                        <button
                            type="button"
                            className="px-4 focus:outline-none text-white hover:text-white transition-all duration-200"
                            onClick={() => {
                                setLocal("");
                                onClear();
                            }}
                            aria-label="Effacer"
                        >
                            <i className="fa-solid fa-xmark fa-lg" />
                        </button>
                    )}
                </form>

                <div
                    className={`-top-10 -left-10 z-10 absolute rounded-100 w-120 h-120 animate-glow1 glow glow-1 group-hover:bg-orange-400 ${glowCls(
                        "bg-orange-400",
                        "bg-orange-400"
                    )}`}
                />
                <div
                    className={`-top-10 -left-10 z-20 absolute rounded-100 w-120 h-120 animate-glow2 glow glow-2 group-hover:bg-orange-500 ${glowCls(
                        "bg-orange-500",
                        "bg-orange-500"
                    )}`}
                />
                <div
                    className={`-top-10 -left-10 z-30 absolute rounded-100 w-120 h-120 animate-glow3 glow glow-3 group-hover:bg-orange-400 ${glowCls(
                        "bg-orange-400",
                        "bg-orange-400"
                    )}`}
                />
                <div
                    className={`-top-10 -left-10 z-40 absolute rounded-100 w-120 h-120 animate-glow4 glow glow-4 group-hover:bg-orange-600 ${glowCls(
                        "bg-orange-600",
                        "bg-orange-600"
                    )}`}
                />
            </div>
    );
};

export default SearchBar;
